// extracted by css-extract-rspack-plugin
export default {"distinction":"_36ff3458","title":"_a53d82ea","description":"_2f95a9cc"};